const tokenClass = (token: string) => {
  if (/^"/.test(token)) {
    return /:$/.test(token) ? "text-blue-700" : "text-emerald-700";
  }
  if (/true|false/.test(token)) return "text-purple-700";
  if (/null/.test(token)) return "text-gray-500";
  return "text-amber-700";
};

/** Colours keys, strings, booleans/null and numbers in already-formatted json. */
export default function highlightJson(json: string) {
  const regex =
    /("(?:\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\btrue\b|\bfalse\b|\bnull\b|-?\d+(?:\.\d+)?(?:[eE][+\-]?\d+)?)/g;
  const tokens: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(json)) !== null) {
    const [token] = match;
    const start = match.index;

    if (start > lastIndex) {
      tokens.push(
        <span key={`plain-${start}`}>{json.slice(lastIndex, start)}</span>
      );
    }

    tokens.push(
      <span key={`token-${start}`} className={tokenClass(token)}>
        {token}
      </span>
    );
    lastIndex = start + token.length;
  }

  if (lastIndex < json.length) {
    tokens.push(<span key={`plain-end`}>{json.slice(lastIndex)}</span>);
  }

  return tokens;
}
